module.exports = __webpack_public_path__ + "static/media/Source Info.16f1ce8d.txt";